import React, {
    memo,
    useEffect,
    useRef,
    useState,
    useCallback,
    useLayoutEffect, useMemo
} from "react";
import styles from "./VideoPage.module.css";
import {useLocation,  useRouteLoaderData} from "react-router-dom";
import VideoCommentPanel from "./components/comments/VideoCommentPanel";
import {useDispatch, useSelector} from "react-redux";
import {AppState} from "src/root/RootReducer";
import {
    incrementVideoViewCount,
    AddViewingHistory,
    loadVideoStarted,
    ResetVideo,
    ResetVideos,
    GetVideoSlide,
    GetVideoCurrentSubtitleStarted,
    SetCurrentVideoCaptions
} from "src/common/video/VideoActions";
import VideoPlayer from "./components/player/VideoPlayer";
import VideoMetaDataPanel from "./components/metaData/VideoInfoPanel";
import VideoSuggestionsPanel from "./components/suggestions/VideoSuggestionsPanel";
import {CircularProgress} from "@material-ui/core";
import VideoDocument from "../../pages/vod/Common/VideoDocument";
// import {ResetUserVideos} from "src/common/homePage/HomePageActions";
import TwoSplitVideoPlayer from "./components/player/TwoSplitVideoPlayer";
import ThreeSplitVideoPlayer from "./components/player/ThreeSplitVideoPlayer";
import RerunSTTComponent from "../../pages/vod/Common/RerunSTT";
import {
    GetVideoOption,
    UpdateStatistics,
    UpdateVideoOption
} from "src/store/actions/ExVideoActions";
import {ConvertCaptionToVtt, isAdmin, isPresenter} from "src/utils/LogicUtils";
import viewPattern1 from "../../assets/image/viewPattern1.svg";
import viewPattern3 from "../../assets/image/viewPattern2.svg";
import viewPattern4 from "../../assets/image/viewPattern3.svg";
import viewPattern1Selected from "../../assets/image/viewPattern1Selected.svg";
import viewPattern3Selected from "../../assets/image/viewPattern2Selected.svg";
import viewPattern4Selected from "../../assets/image/viewPattern3Selected.svg";
import useResponsive from "../../common/useResponsive";
import {VideoCaption} from "src/models/video";
import {useQuery} from "@tanstack/react-query";
import {isEmpty, isNil} from "lodash";
import {Survey} from "src/models/survey";
import SurveyModal from "./components/survey-modal";
import {css} from "@emotion/css";

// 10秒ごとに視聴時間を記録する
const VIDEO_TIME_UPDATE_INTERVAL_MS = 1000;
// 視聴数カウント条件
const VIEW_COUNT_MINIMUM_WATCHED_TIME_MS = 2000;

// TODO this component has grown far too big
function VideoPage() {
    const videoData = useRouteLoaderData("videoDetail") as {
      id: string
    };
    const {userInfo, isRerunSTT, videoOption, video, isResetVideo} =
      useSelector((state: AppState) => {
          return {
              userInfo: state.user.userInfo,
              isRerunSTT: state.exVideo.caption.isRerunSTT,
              videoOption: state.exVideo.videoOption,
              video: state.video.video,
              isResetVideo: state.video.isResetVideo
          };
      });
    const videoRef = useRef<HTMLVideoElement>(null);
    const dispatch = useDispatch();
    const location = useLocation();
    const {data:surveyList} = useQuery<Survey[]>({
        enabled:!(isNil(userInfo?.id) || isEmpty(videoData.id)),
        queryKey:["/api/getSurveyList",{
            params:{
                userId:userInfo?.id,
                videoId:videoData.id
            }
        }]
    });
    const publicSurveyList = useMemo(() => surveyList?.filter(item => {
        return item.isPublic && (item.multipleAnswer || item.questionList.find(q => isEmpty(q.answerHistory)));
    }),[surveyList]);
    const {isDesktop} = useResponsive();

    const [hasUpdatedViewCount, setHasUpdatedViewCount] =
      useState<boolean>(false);
    const [currentVideoTimeMs, setCurrentVideoTimeMs] = useState<number>(
        videoRef.current?.currentTime || 0
    );
    const [currentTime, ChangeCurrentTime] = useState(0);
    // スライド自動変更用
    const [checkTimeMs, setCheckTimeMs] = useState<number>(0);
    // 選択している言語
    const [selectedLanguage, setSelectedLanguage] = useState("");
    // 多言語字幕のキャシュー
    const [allCaptionsCache, setAllCaptionsCache] = useState<Map<string, VideoCaption[]>>(new Map());

    // 修正後の字幕内容
    const currentVideoCaptions = useSelector((state: AppState) =>
        state.video.currentVideoCaptions
    );

    // 修正後の字幕内容を監視する。
    useEffect(() => {
    // 更新後の字幕設定する。
        if (currentVideoCaptions && videoRef && videoRef.current && videoRef.current?.textTracks) {
            const textTracks = Array.from(videoRef.current?.textTracks || []);
            const activeTrackIndex = textTracks.findIndex(track => track.language === selectedLanguage);
            const htmlTrackElement = Array.from(videoRef.current?.children).find(
                child => child.tagName === "TRACK" && child["track"] === textTracks[activeTrackIndex]
            );

            if (htmlTrackElement) {
                htmlTrackElement.setAttribute("src", ConvertCaptionToVtt("subtitles", currentVideoCaptions));
            }

        }
    }, [currentVideoCaptions]);


    // APIから取得した字幕データ
    const {currentLanguage, subtitlesData} = useSelector((state: AppState) => ({
        currentLanguage: state.subtitle.currentLanguage,
        subtitlesData: state.subtitle.captions
    }));

    // 画面遷移を監視
    useEffect(() => {
        if (video) {
            // dispatch(ResetUserVideos());
            dispatch(ResetVideos());
            dispatch(ResetVideo());
        }
    }, [location]);

    // タグフォーマット
    const makeTagStr = (videoTags: string[]) => {
        let tagList = "";
        for (let index = 0; index < videoTags.length; index++) {
            tagList = tagList.concat(videoTags[index]);
        }
        return tagList;
    };

    // 画面表示パターン
    const [viewPattern, SwitchViewPattern] = useState(1);
    const ClickSwitchViewButton = (pattern: number) => {
        const isPlay = videoRef.current
            ? !videoRef.current.paused
            : videoOption.isPlay;
        if (isAdmin(userInfo?.roles)) {
            if (pattern !== 1) {
                dispatch(
                    UpdateVideoOption(
                        isPlay,
                        videoOption.isVisibleCaption,
                        videoOption.isMuted,
                        pattern
                    )
                );
                SwitchViewPattern(pattern);
            } else {
                if (videoOption.isVisibleCaption === true) {
                    dispatch(
                        UpdateVideoOption(
                            isPlay,
                            videoOption.isVisibleCaption,
                            videoOption.isMuted,
                            2
                        )
                    );
                    SwitchViewPattern(2);
                } else {
                    dispatch(
                        UpdateVideoOption(
                            isPlay,
                            videoOption.isVisibleCaption,
                            videoOption.isMuted,
                            1
                        )
                    );
                    SwitchViewPattern(1);
                }
            }
        } else {
            if (pattern === 1) {
                if (video && video.publicCaption) {
                    if (videoOption.isVisibleCaption === true) {
                        dispatch(
                            UpdateVideoOption(
                                isPlay,
                                videoOption.isVisibleCaption,
                                videoOption.isMuted,
                                2
                            )
                        );
                        SwitchViewPattern(2);
                    } else {
                        dispatch(
                            UpdateVideoOption(
                                isPlay,
                                videoOption.isVisibleCaption,
                                videoOption.isMuted,
                                1
                            )
                        );
                        SwitchViewPattern(1);
                    }
                } else {
                    dispatch(
                        UpdateVideoOption(
                            isPlay,
                            videoOption.isVisibleCaption,
                            videoOption.isMuted,
                            1
                        )
                    );
                    SwitchViewPattern(2);
                }
            } else {
                dispatch(
                    UpdateVideoOption(
                        isPlay,
                        videoOption.isVisibleCaption,
                        videoOption.isMuted,
                        pattern
                    )
                );
                SwitchViewPattern(pattern);
            }
        }
    };
    // ビデオ詳細情報取得（STTを含む）
    useEffect(() => {

        if (userInfo?.id && isResetVideo) {
            dispatch(loadVideoStarted(videoData.id, userInfo.id));
        }

    }, [userInfo.id, isResetVideo, videoData.id, videoData, dispatch]);

    useEffect(() => {
        if (video) {
            if (video.slideFlg === true) {
                dispatch(GetVideoSlide(String(video.id), "1"));
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [video]);

    // 再生オプション取得
    useEffect(() => {
        dispatch(GetVideoOption());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // 多言語ステータス
    const [subtitles, setSubtitles] = useState([]);

    useEffect(() => {
        if (video) {
            // 多言語track初期化
            initSubtitles();

            if (isAdmin(userInfo?.roles)) {
                // Slide資料がある場合
                if (video?.slideFlg) {
                    SwitchViewPattern(videoOption.viewPattern);
                } else {
                    if (videoOption.viewPattern === 1 || videoOption.viewPattern === 2) {
                        SwitchViewPattern(videoOption.viewPattern);
                    } else {
                        SwitchViewPattern(1);
                    }
                }

            } else {

                if (video?.slideFlg) {
                    SwitchViewPattern(videoOption.viewPattern);
                } else {
                    if (
                        videoOption.viewPattern === 1 ||
              videoOption.viewPattern === 2
                    ) {
                        SwitchViewPattern(videoOption.viewPattern);
                    } else {
                        SwitchViewPattern(1);
                    }
                }
            }

            // 履歴がある場合、視聴履歴の秒数を指定
            if (video && video.viewingActivities.length > 0) {
                const progressMillis = video.viewingActivities[0].progressMillis;
                if (videoRef.current)
                    videoRef.current.currentTime = Math.floor(progressMillis / 1000);
                setCheckTimeMs(progressMillis);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [video]);

    // 10秒ごとに視聴時間を記録する
    const updateTimeAndViewCountStatus = useCallback(() => {
        if (videoRef && videoRef.current?.currentTime) {
            // スライド自動変更用
            setCheckTimeMs(videoRef.current.currentTime * 1000);
            ChangeCurrentTime(videoRef.current.currentTime * 1000);
            const newCurrentTimeS = Math.floor(videoRef.current.currentTime * 1000);
            const intervel = newCurrentTimeS - currentVideoTimeMs;
            // 視聴ビデオの第2秒
            if (
                newCurrentTimeS >= VIEW_COUNT_MINIMUM_WATCHED_TIME_MS &&
          newCurrentTimeS < 3000 &&
          !hasUpdatedViewCount
            ) {
                setHasUpdatedViewCount(true);
                if (userInfo && video)
                    dispatch(incrementVideoViewCount(userInfo.id, video.id));
                if (userInfo && video) {
                    dispatch(AddViewingHistory(userInfo.id, video.id, newCurrentTimeS));
                    dispatch(
                        UpdateStatistics(
                            Number(userInfo.id),
                            video.id,
                            makeTagStr(video.tags),
                            video.title,
                            video.imageUrl,
                            newCurrentTimeS,
                            true
                        )
                    );
                }
            }
            // 視聴ビデオの10秒間隔
            if (newCurrentTimeS > 3000 && intervel >= 10000) {
                setCurrentVideoTimeMs(newCurrentTimeS);
                if (userInfo && video) {
                    dispatch(AddViewingHistory(userInfo.id, video.id, newCurrentTimeS));
                    dispatch(
                        UpdateStatistics(
                            Number(userInfo.id),
                            video.id,
                            makeTagStr(video.tags),
                            video.title,
                            video.imageUrl,
                            newCurrentTimeS,
                            false
                        )
                    );
                }
                setHasUpdatedViewCount(true);
            }
            // ビデオ進捗バーをクリック時
            if (intervel < 0) {
                setCurrentVideoTimeMs(newCurrentTimeS);
                if (userInfo && video) {
                    dispatch(AddViewingHistory(userInfo.id, video.id, newCurrentTimeS));
                    dispatch(
                        UpdateStatistics(
                            Number(userInfo.id),
                            video.id,
                            makeTagStr(video.tags),
                            video.title,
                            video.imageUrl,
                            newCurrentTimeS,
                            false
                        )
                    );
                }
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dispatch,
        userInfo,
        videoRef,
        video,
        currentVideoTimeMs,
        hasUpdatedViewCount
    ]);

    // 1秒ごとのループを設定
    useEffect(() => {
        const intervalId = setInterval(
            updateTimeAndViewCountStatus,
            VIDEO_TIME_UPDATE_INTERVAL_MS
        );
        return () => clearInterval(intervalId);
    }, [updateTimeAndViewCountStatus]);

    useEffect(() => {
    // ビデオ再生停止
        videoRef.current?.addEventListener("pause", () => {
            console.log("ビデオ再生停止");
            const stopVideoTimeMS = videoRef.current?.currentTime;
            if (video && userInfo && stopVideoTimeMS) {
                // console.log("停止：", userInfo.id,video.id, Math.floor(stopVideoTimeMS * 1000))
                setCurrentVideoTimeMs(Math.floor(stopVideoTimeMS * 1000));
                dispatch(
                    AddViewingHistory(
                        userInfo.id,
                        video.id,
                        Math.floor(stopVideoTimeMS * 1000)
                    )
                );
                dispatch(
                    UpdateStatistics(
                        Number(userInfo.id),
                        video.id,
                        makeTagStr(video.tags),
                        video.title,
                        video.imageUrl,
                        Math.floor(stopVideoTimeMS * 1000),
                        false
                    )
                );
            }
        });

        // ビデオ再生開始
        videoRef.current?.addEventListener("play", () => {
            console.log("ビデオ再生開始");
            if (videoRef.current?.muted === false) {
                dispatch(
                    UpdateVideoOption(
                        true,
                        videoOption.isVisibleCaption,
                        false,
                        videoOption.viewPattern
                    )
                );
            } else {
                dispatch(
                    UpdateVideoOption(
                        true,
                        videoOption.isVisibleCaption,
                        true,
                        videoOption.viewPattern
                    )
                );
            }
        });

        // 音量変化
        videoRef.current?.addEventListener("volumechange", () => {
            if (videoRef.current?.muted === true) {
                if (videoOption.isMuted === false) {
                    console.log("音量ミュート");
                    dispatch(
                        UpdateVideoOption(
                            videoOption.isPlay,
                            videoOption.isVisibleCaption,
                            true,
                            videoOption.viewPattern
                        )
                    );
                }
            } else {
                if (videoOption.isMuted === true) {
                    console.log("音量ミュート以外に変更");
                    dispatch(
                        UpdateVideoOption(
                            videoOption.isPlay,
                            videoOption.isVisibleCaption,
                            false,
                            videoOption.viewPattern
                        )
                    );
                }
            }
        });

        // 字幕表示切り替え
        videoRef.current?.textTracks.addEventListener("change", () => {
            // 字幕切り替える場合
            const textTracks = Array.from(videoRef.current?.textTracks || []);
            const activeTrackIndex = textTracks.findIndex(track => track.mode === "showing");
            const currentSrc = getCurrentSubtitleTrackSrc(textTracks[activeTrackIndex]);
            const lang = activeTrackIndex >= 0 ?
                textTracks[activeTrackIndex].language || video.language :
                video.language;

            // 言語設定
            setSelectedLanguage(lang);

            // 字幕存在しない場合、APIから字幕を取得する。
            if (activeTrackIndex >= 0 && !currentSrc) {
                dispatch(GetVideoCurrentSubtitleStarted(video.id, textTracks[activeTrackIndex].language));
            }

            // 字幕表示の場合
            if (activeTrackIndex >= 0) {
                if (videoOption.viewPattern === 1) {
                    console.log("字幕表示");
                    dispatch(
                        UpdateVideoOption(videoOption.isPlay, true, videoOption.isMuted, 2)
                    );
                    SwitchViewPattern(2);
                } else {
                    if (videoOption.isVisibleCaption === false) {
                        console.log("字幕表示");
                        dispatch(
                            UpdateVideoOption(
                                videoOption.isPlay,
                                true,
                                videoOption.isMuted,
                                videoOption.viewPattern
                            )
                        );
                    }
                }
                // 字幕非表示の場合
            } else {
                if (videoOption.viewPattern === 2) {
                    console.log("字幕非表示");
                    dispatch(
                        UpdateVideoOption(videoOption.isPlay, false, videoOption.isMuted, 1)
                    );
                    SwitchViewPattern(1);
                } else {
                    if (videoOption.isVisibleCaption === true) {
                        console.log("字幕非表示");
                        dispatch(
                            UpdateVideoOption(
                                videoOption.isPlay,
                                false,
                                videoOption.isMuted,
                                videoOption.viewPattern
                            )
                        );
                    }
                }
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, videoRef.current]);

    /**
   *  新しい字幕設定
   */
    const setNewSubtitle = useCallback(async () => {
        const textTracks = Array.from(videoRef.current?.textTracks || []);
        if (!video || !currentLanguage || !subtitlesData || textTracks.length < 1) {
            // 処理なし
            return;
        }

        // 該当最新字幕設定
        dispatch(SetCurrentVideoCaptions(subtitlesData));

        // 新しいビデオのオリジナル言語追加
        setAllCaptionsCache(prev => new Map(prev).set(currentLanguage, subtitlesData));
        setSelectedLanguage(currentLanguage);

        const activeTrackIndex = textTracks.findIndex(track => track.language === currentLanguage);
        const htmlTrackElement = Array.from(videoRef.current?.children).find(
            child => child.tagName === "TRACK" && child["track"] === textTracks[activeTrackIndex]
        );
        if (htmlTrackElement) {
            htmlTrackElement.setAttribute("src", ConvertCaptionToVtt("subtitles", subtitlesData));
        }
    }, [currentLanguage, subtitlesData]);

    useEffect(() => {
        if (!video || !allCaptionsCache) {
            return;
        }
        if (!selectedLanguage) {
            dispatch(SetCurrentVideoCaptions(allCaptionsCache.get(video.language)));
            return;
        }
        dispatch(SetCurrentVideoCaptions(allCaptionsCache.get(selectedLanguage)));
    }, [selectedLanguage]);

    // 選択肢に言語切り替えを監視する
    useEffect(() => {
        setNewSubtitle();
    }, [setNewSubtitle]);

    /**
   * 多言語trackロード
   */
    function initSubtitles() {
    // ビデオのオリジナル言語設定
        dispatch(SetCurrentVideoCaptions(video.captions));
        // 初期化の場合はビデオのオリジナル言語を設定する。その以外の場合、選択言語を保持する。
        let newLanguage = selectedLanguage;
        if (!newLanguage) {
            newLanguage = video.language;
        }
        setAllCaptionsCache(prev => new Map(prev).set(newLanguage, video.captions));
        setSelectedLanguage(newLanguage);

        // 多言語trackロード
        const newSubtitles = [];
        Object.keys(video.supportLanguage || {}).map((key) => {
            let src = "";
            // ビデオのオリジナル字幕設定
            if (key === video.language) {
                src = ConvertCaptionToVtt("subtitles", video.captions);
            }
            newSubtitles.push({
                id: key + "Subtitle",
                srcLang: key,
                src: src,
                label: video.supportLanguage[key]
            });
        });

        // 多言語内容設定
        setSubtitles(newSubtitles);
    }

    /**
   *  字幕情報のsrc取得
   *
   * @param track 該当字幕
   * @returns 字幕情報のsrc
   */
    function getCurrentSubtitleTrackSrc(track: TextTrack) {
        const htmlTrackElement = Array.from(videoRef.current?.children).find(
            child => child.tagName === "TRACK" && child["track"] === track
        );
        if (htmlTrackElement) {
            return htmlTrackElement.getAttribute("src");
        }
        return "";
    }

    // ビデオ押下
    const ClickVideo = (event: any) => {
        console.log("ClickVideo start");
        if (videoRef.current?.paused === false) {
            dispatch(
                UpdateVideoOption(
                    false,
                    true,
                    videoOption.isMuted,
                    videoOption.viewPattern
                )
            );
        } else {
            dispatch(
                UpdateVideoOption(
                    true,
                    videoOption.isVisibleCaption,
                    videoOption.isMuted,
                    videoOption.viewPattern
                )
            );
        }
    };

    useLayoutEffect(() => {
    // video playback progress will start from the specified chapter if Play action is clicked on the search page
        if (location.search) {
            const query = new URLSearchParams(location.search);
            const timeStr = query.get("time"); // e.g.  "59s", "1m59s", "2m59m"
            if (timeStr) {
                // Match minutes (m) and seconds (s)
                const minuteMatch = timeStr.match(/(\d+)m/); // 1m, 59m, 2m
                const secondMatch = timeStr.match(/(\d+)s/); // 59s
                let progressSecs = 0;
                if (minuteMatch) {
                    progressSecs += parseInt(minuteMatch[1], 10) * 60;
                }
                if (secondMatch) {
                    progressSecs += parseInt(secondMatch[1], 10);
                }
                if (videoRef.current) {
                    videoRef.current.onloadedmetadata = () => {
                        videoRef.current.currentTime = progressSecs;
                    };
                }
                ChangeCurrentTime(progressSecs * 1000);
                return;
            }
        }
        if (!location.state || !location.state.time) {
            if (video && video.viewingActivities.length > 0) {
                const progressMillis = video.viewingActivities[0].progressMillis;
                console.log("履歴：", progressMillis);
                if (videoRef && videoRef.current)
                    videoRef.current.currentTime = Math.floor(progressMillis / 1000);
                setCheckTimeMs(progressMillis);
            }
            return;
        }
        const initialTime = location.state.time;
        if (initialTime && videoRef && videoRef.current) {
            videoRef.current.currentTime = Math.floor(initialTime / 1000);
        }
    }, [location, dispatch, video, videoRef]);

    // const SwitchCaptionPublicState = () => {
    //   if (video && userInfo) {
    //     dispatch(
    //       UpdateCaptionPublicState(
    //         Number(userInfo?.id),
    //         video?.id,
    //         !video?.publicCaption,
    //         true
    //       )
    //     );
    //   }
    // };

    if (!video || isRerunSTT) {
        return (
            <div className={styles.noContent}>
                <CircularProgress size={60} style={{color: "var(--red)"}}/>
            </div>
        );
    }

    const isPre = video.presenterId == userInfo?.id && isPresenter(userInfo?.roles);
    return (
        <>
            <div className={styles.switchViewButton}>
                {(isAdmin(userInfo?.roles) || isPre) && isDesktop && (video.captions && video.captions.length > 0) && (
                    <div
                        style={{display: "flex", width: "240px", position: "relative"}}
                    >
                        {/* <FormControlLabel
              control={
                <Switch
                  checked={video.publicCaption}
                  onChange={SwitchCaptionPublicState}
                  name="checkedA"
                />
              }
              label={(
                <PuiTypography size={isMobile ? 14 : 16}>
                  {video.publicCaption ? "STT公開" : "STT非公開"}
                </PuiTypography>
              )}
            /> */}
                        <div className={styles.rerunStt}>
                            <RerunSTTComponent videoLanguage={video.language} videoId={video.id}/>
                        </div>
                    </div>
                )}
                {video?.slideFlg && (
                    <div className={styles.switchViewPatternButtonGroup}>
                        {viewPattern === 1 || viewPattern === 2 ? (
                            <img
                                alt="viewPattern1Selected"
                                src={viewPattern1Selected}
                                title="ビデオと字幕"
                                height="50px"
                                width="50px"
                            />
                        ) : (
                            <img
                                alt="viewPattern1"
                                src={viewPattern1}
                                height="50px"
                                title="ビデオと字幕"
                                width="50px"
                                onClick={() => ClickSwitchViewButton(1)}
                                style={{cursor: "pointer"}}
                            />
                        )}
                        {viewPattern === 3 ? (
                            <img
                                alt="viewPattern3Selected"
                                src={viewPattern3Selected}
                                title="ビデオとファイル"
                                height="50px"
                                width="50px"
                            />
                        ) : (
                            <img
                                alt="viewPattern3"
                                src={viewPattern3}
                                height="50px"
                                width="50px"
                                title="ビデオとファイル"
                                onClick={() => ClickSwitchViewButton(3)}
                                style={{cursor: "pointer"}}
                            />
                        )}
                        {
                            (viewPattern === 4 ? (
                                <img
                                    alt="viewPattern4Selected"
                                    src={viewPattern4Selected}
                                    title="全て表示"
                                    height="50px"
                                    width="50px"
                                />
                            ) : (
                                <img
                                    alt="viewPattern4"
                                    src={viewPattern4}
                                    title="全て表示"
                                    height="50px"
                                    width="50px"
                                    onClick={() => ClickSwitchViewButton(4)}
                                    style={{cursor: "pointer"}}
                                />
                            ))}
                    </div>
                )}
            </div>
            <div className={styles.cue}>
                {/* １画面再生 */}
                {(viewPattern === 1 || viewPattern === 2) && (
                    <div className={styles.root}>
                        <VideoPlayer
                            video={video}
                            videoRef={videoRef}
                            currentVideoTimeMs={currentTime}
                            subtitles={subtitles}
                            videoCaptions={currentVideoCaptions}
                            ClickVideo={ClickVideo}
                        />
                        <div className={styles.meta}>
                            <div className={styles.metaLeft}>
                                <VideoMetaDataPanel video={video}/>

                                <div className={styles.materials}>
                                    <VideoDocument documentList={video.extraMaterials}/>
                                </div>

                                <div className={styles.comments}>
                                    <VideoCommentPanel
                                        comments={video.comments}
                                        videoId={video.id}
                                        videoRef={videoRef}
                                    />
                                </div>
                            </div>
                            <div className={styles.metaRight}>
                                <VideoSuggestionsPanel videoId={video.id}/>
                            </div>
                        </div>
                    </div>
                )}
                {/* １画面字幕再生 */}
                {/* {viewPattern === 2 && (
          <div className={styles.root}>
            <VideoPlayerWithSubs
              video={video}
              videoRef={videoRef}
              currentVideoTimeMs={checkTimeMs}
              track={track}
              ClickVideo={ClickVideo}
            />
            <div className={styles.meta}>
              <div className={styles.metaLeft}>
                <VideoMetaDataPanel video={video} />

                <div className={styles.materials}>
                  <VideoDocument documentList={video.extraMaterials} />
                </div>

                <div className={styles.comments}>
                  <VideoCommentPanel
                    comments={video.comments}
                    videoId={video.id}
                    videoRef={videoRef}
                  />
                </div>
                <div className={styles.comments}>
                  <VideoCommentPanel
                    comments={video.comments}
                    videoId={video.id}
                    videoRef={videoRef}
                  />
                </div>
              </div>
              <div className={styles.metaRight}>
                <VideoSuggestionsPanel videoId={video.id} />
              </div>
            </div>
          </div>
        )} */}

                {/* ２画面再生 */}
                {viewPattern === 3 && (
                    <div className={styles.root}>
                        <TwoSplitVideoPlayer
                            video={video}
                            videoRef={videoRef}
                            currentVideoTimeMs={checkTimeMs}
                            subtitles={subtitles}
                            ClickVideo={ClickVideo}
                        />
                    </div>
                )}

                {/* ３画面再生 */}
                {viewPattern === 4 && (
                    <div className={styles.root}>
                        <ThreeSplitVideoPlayer
                            video={video}
                            videoRef={videoRef}
                            currentVideoTimeMs={checkTimeMs}
                            subtitles={subtitles}
                            videoCaptions={currentVideoCaptions}
                            ClickVideo={ClickVideo}

                        />
                    </div>
                )}
            </div>
            {!isEmpty(publicSurveyList) && <SurveyModal
                surveys={publicSurveyList}
                currentVideoTimeMs={
                    videoRef.current
                        ? videoRef.current.currentTime * 1000
                        : currentVideoTimeMs
                }
                videoRef={videoRef}
            />}
        </>
    );
}
function VideoPageError() {
    const videoData = useRouteLoaderData("videoDetail") as {
    id: string,
    errorMsg: string,
  };
    return (
        <div className={css`
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100%;
          font-size: 18px;
          color: #D1161B;
        `}
        >
            {videoData.errorMsg}
        </div>
    );
}
function VideoPageWrapper() {
    const videoData = useRouteLoaderData("videoDetail") as {
    id: string,
      errorMsg: string,
  };
    console.log("VideoPageWrapper videoData:", videoData);
    if (videoData.errorMsg) {
        return <VideoPageError/>;
    }
    return <VideoPage/>;
}
export default memo(VideoPageWrapper);
